import { withActions } from "core/redux/hoc";
import * as insidersApi from "modules/insiders/api";
import View from "./View";

export default withActions({
  loadMore: ({ insider }) => next =>
    insidersApi.getAvailableTime.request({ next, id: insider.id })
})(View);



// WEBPACK FOOTER //
// ./src/components/common/candidate/TimeSlots/Provider.js